import React, { useEffect, useState } from 'react';
import ParentCardNoCol from '../../../common/ParentCardNoCol';
import ToggleButton from '../../../../common/ui/ToggleButton';
import CustomInputWithIcon from '../../../../common/ui/CustomInputWithIcon';
import CustomSelect from '../../../../common/formElements/CustomSelect';
import { drapcodeIcon } from '../../../../common/custom/icon-library';
import { COUNTRY_OPTIONS } from '../../../../common/utils/constant';
import {
  disableDataMasking,
  disableIt,
  enableDataMasking,
  enableIt,
} from '../../../../common/docs/content';
import showAlert from '../../../../common/utils/alert';
import { toast } from 'react-toastify';

export const DataMasking = ({ projectId, version, actions, dataMasking }) => {
  const [isMaskingEnabled, setIsMaskingEnabled] = useState(
    dataMasking && dataMasking.enabled ? dataMasking.enabled : false,
  );
  const [selectedCountries, setSelectedCountries] = useState(() =>
    dataMasking && Array.isArray(dataMasking.allowedCountries) ? dataMasking.allowedCountries : [],
  );

  const [isToggleLoading, setIsToggleLoading] = useState(false);
  const [isCountriesLoading, setIsCountriesLoading] = useState(false);
  const [countriesError, setCountriesError] = useState('');

  useEffect(() => {
    setIsMaskingEnabled(dataMasking && dataMasking.enabled ? dataMasking.enabled : false);
  }, [dataMasking]);

  const handleToggle = async () => {
    const newValue = !isMaskingEnabled;
    try {
      setIsToggleLoading(true);
      const preConfirm = () => {
        actions.toggleDataMasking({
          projectId,
          version,
          projectId,
          version,
          data: {
            enabled: newValue,
            allowedCountries: selectedCountries,
          },
        });
        setIsMaskingEnabled(newValue);
      };
      showAlert(
        newValue ? enableDataMasking : disableDataMasking,
        preConfirm,
        newValue ? enableIt : disableIt,
      );
    } catch (error) {
      console.error('Failed to update data masking:', error);
    } finally {
      setIsToggleLoading(false);
    }
  };

  const handleCountriesChange = (name, value) => {
    const countries = value || [];
    setSelectedCountries(countries);
    if (countries.length > 0) {
      setCountriesError('');
    }
  };

  const handleUpdateCountries = async () => {
    if (selectedCountries.length === 0) {
      setCountriesError('Please select at least one allowed country.');
      return;
    }

    setCountriesError('');
    try {
      setIsCountriesLoading(true);
      await actions.toggleDataMasking({
        projectId,
        version,
        data: {
          enabled: true,
          allowedCountries: selectedCountries,
        },
      });
    } catch (error) {
      console.error('Failed to update allowed countries:', error);
    } finally {
      setIsCountriesLoading(false);
    }
  };

  return (
    <ParentCardNoCol title="Data Masking" icon="lock" bgColor="drapcode-violet">
      <div className="col-md-12 col-lg-12 mt-2">
        <div className="d-flex justify-content-between align-items-center">
          <div>
            <strong>Mask Data Based on Location</strong>

            <div className="text-muted small mt-1">
              Mask sensitive data when requests originate from countries outside the allowed list.
            </div>
          </div>

          <ToggleButton
            name="enableDataMasking"
            title="Enable Data Masking by Location"
            text="Enable Data Masking by Location"
            bgColor="drapcode-violet"
            onChange={handleToggle}
            isChecked={isMaskingEnabled ? 'checked' : ''}
            disabled={isToggleLoading}
          />
        </div>

        {isMaskingEnabled && (
          <>
            <div className="row mt-4">
              <div className="col-md-12 col-lg-12 col-sm-12 col-xs-12">
                <CustomInputWithIcon title="Allowed Countries" icon="globe" required={true}>
                  <CustomSelect
                    name="allowedCountries"
                    isMulti={true}
                    onChange={handleCountriesChange}
                    options={COUNTRY_OPTIONS}
                    value={selectedCountries}
                    placeholder="Select Allowed Countries"
                    isDisabled={isCountriesLoading}
                  />
                </CustomInputWithIcon>
                {countriesError && <div className="text-danger small ml-5">{countriesError}</div>}
              </div>
            </div>

            <div className="row mt-3">
              <div className="col-md-12 text-right">
                <button
                  type="button"
                  className="btn btn-theme-submit btn-md"
                  onClick={handleUpdateCountries}
                  disabled={isCountriesLoading}
                >
                  <i className={`wb ${drapcodeIcon('save')}`}></i>
                  &nbsp;
                  {isCountriesLoading ? 'Updating...' : 'Update'}
                </button>
              </div>
            </div>
          </>
        )}
      </div>
    </ParentCardNoCol>
  );
};
